/** @jsx jsx */
import { jsx, css } from "@emotion/core";
const FilterContainer = css({
    padding: "0 0em 2em",
    marginTop: "0",
    width: "auto",
    height: "unset"
});
// @ts-ignore
const CityFilterPillStyle = css({
    height: "2.5em",
    width: "12em",
    border: "1px solid #999",
    borderRadius: "50px",
    fontWeight: "400",
    fontSize: "16px",
    background: "url(/assets/images/icons/downchevron.svg) no-repeat right #ffffff",
    appearance: "none",
    "-moz-appearance": "none",
    "-webkit-appearance": "none",
    padding: "0 16px",
    backgroundPositionX: "90%",
    outline: "none",
});
export const MonumentsCityDropdown = ({ monumentCities, setCurrentCityFilter, currentCityFilter }) => {
    return (<div className={"select-field-parent"}>
			<div className={"select-field-parent-content"} css={FilterContainer}>
				<div className="header">CITY:</div>
				<select value={currentCityFilter} onChange={setCurrentCityFilter} css={CityFilterPillStyle}>
					{monumentCities.map(city => {
            return <option>{city}</option>;
        })}
				</select>
			</div>
		</div>);
};
